import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Eye, MousePointerClick, Users, TrendingUp } from "lucide-react";

interface JobViewsMetricsProps {
  totalViews: number;
  uniqueViews: number;
  totalClicks: number;
  conversionRate: number;
}

export function JobViewsMetrics({ totalViews, uniqueViews, totalClicks, conversionRate }: JobViewsMetricsProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 p-3 md:p-6 md:pb-2">
          <CardTitle className="text-xs md:text-sm font-medium">Total de Visualizações</CardTitle>
          <Eye className="h-4 w-4 text-muted-foreground hidden sm:block" />
        </CardHeader>
        <CardContent className="p-3 pt-0 md:p-6 md:pt-0">
          <div className="text-xl md:text-2xl font-bold">{totalViews}</div>
          <p className="text-[10px] md:text-xs text-muted-foreground">
            Todas as visualizações
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 p-3 md:p-6 md:pb-2">
          <CardTitle className="text-xs md:text-sm font-medium">Visualizações Únicas</CardTitle>
          <Users className="h-4 w-4 text-muted-foreground hidden sm:block" />
        </CardHeader>
        <CardContent className="p-3 pt-0 md:p-6 md:pt-0">
          <div className="text-xl md:text-2xl font-bold">{uniqueViews}</div>
          <p className="text-[10px] md:text-xs text-muted-foreground">
            Usuários únicos
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 p-3 md:p-6 md:pb-2">
          <CardTitle className="text-xs md:text-sm font-medium">Cliques em Candidatar</CardTitle>
          <MousePointerClick className="h-4 w-4 text-muted-foreground hidden sm:block" />
        </CardHeader>
        <CardContent className="p-3 pt-0 md:p-6 md:pt-0">
          <div className="text-xl md:text-2xl font-bold">{totalClicks}</div>
          <p className="text-[10px] md:text-xs text-muted-foreground">
            Redirecionamentos
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 p-3 md:p-6 md:pb-2">
          <CardTitle className="text-xs md:text-sm font-medium">Taxa de Conversão</CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground hidden sm:block" />
        </CardHeader>
        <CardContent className="p-3 pt-0 md:p-6 md:pt-0">
          <div className="text-xl md:text-2xl font-bold">{conversionRate.toFixed(1)}%</div>
          <p className="text-[10px] md:text-xs text-muted-foreground">
            Cliques / Views
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
